module.exports = __webpack_public_path__ + "img/shop01.2b0d0af2.png";